<template>
  <div id="company-editor" class="font-jumper">

    <div class="mb-5">
      <b-alert class="shadow-lg" v-if="company.beforeOnboardingCompany" show dismissible>A fiókbeállításaid készen vannak . Amennyiben az adatokban változás történik, vagy olyat látsz, ami már nem aktuális, kérjük haladéktalanul jelezd ügyfélszolgálatunknak.</b-alert>
      <b-alert class="shadow-lg" v-if="!company.beforeOnboardingCompany && company.onboardingDate === null" show
               dismissible>Köszöntünk a kényelmes könyvelés világában. Kollégáink hamarosan kérni fognak tőled 3 időpontot, amely alkalmas lehet egy 20-30 perces beléptetési hívásra, hogy fiókod mielőbb megtelhessen vállalkozásod adataival.
      </b-alert>
      <b-alert class="shadow-lg" v-if="!company.beforeOnboardingCompany && company.onboardingDate !== null" show
               dismissible><p>Vállalkozásod adatait a beléptetési hívás után tudjuk véglegesíteni. A hívás időpontja: {{ formatDate(company.onboardingDate) }}</p>
        <p>Az online megbeszélés linkjét emailben küldjük.</p>
        <p>Kérjük feltétlenül készülj fel a beszélgetésre a következőkkel: bankszámláid, értékpapírjaid, futárszolgálataid, termináljaid, pályázataid, hiteleid alapadatai.</p>

      </b-alert>
      <b-alert class="shadow-lg" v-if="company.onboardingFinished" show dismissible>A fiókbeállításaid készen vannak . Amennyiben az adatokban változás történik, vagy olyat látsz, ami már nem aktuális, kérjük haladéktalanul jelezd ügyfélszolgálatunknak. </b-alert>
    </div>

    <div class="px-3">

      <!-- Company basic fields -->
      <h5 class="bold">Cégnév</h5>
      <div class="field-wrapper">
        <div>{{ company.name }}</div>
      </div>

      <h5 class="bold">Rövid cégnév</h5>
      <div class="field-wrapper">
        <div>{{ company.shortName }}</div>
      </div>

      <h5 class="bold">Adószám</h5>
      <div class="field-wrapper">
        <div>{{ company.taxNumber }}</div>
      </div>

      <h5 class="bold">Székhely</h5>
      <div class="field-wrapper">
        <div>{{ company.headquarter ? company.headquarter : '-' }}</div>
      </div>

      <!--    <h5 class="bold">Onboarding előtti cég</h5>-->
      <!--    <div class="field-wrapper">-->
      <!--      <div>{{ company.beforeOnboardingCompany ? 'Igen' : 'Nem' }}</div>-->
      <!--    </div>-->

      <!--    <h5 class="bold">Onboarding dátuma</h5>-->
      <!--    <div class="field-wrapper">-->
      <!--      <div>{{ company.onboardingDate || '-' }}</div>-->
      <!--    </div>-->

      <!--    <h5 class="bold">Onboarding befejezve</h5>-->
      <!--    <div class="field-wrapper">-->
      <!--      <div>{{ company.onboardingFinished ? 'Igen' : 'Nem' }}</div>-->
      <!--    </div>-->

      <!-- Company full info fields -->
      <div v-if="company.companyFullInfo">
        <h5 class="bold mt-4">Cégforma</h5>
        <div class="field-wrapper">
          <div>{{ company.companyFullInfo?.companyForm }}</div>
        </div>

        <div v-if="company.companyFullInfo?.companyForm !== 'Egyéni vállalkozás'">
          <h5 class="bold">Cég típusa</h5>
          <div class="field-wrapper">
            <div>{{ company.companyFullInfo?.companyType }}</div>
          </div>
        </div>

        <h5 class="bold">Adózási forma</h5>
        <div class="field-wrapper">
          <div>{{ company.companyFullInfo?.taxForm }}</div>
        </div>

        <h5 class="bold">Adózási gyakoriság</h5>
        <div class="field-wrapper">
          <div>{{ company.companyFullInfo?.taxFrequency }}</div>
        </div>

        <h5 class="bold">EU adószám</h5>
        <div class="field-wrapper">
          <div>{{ company.companyFullInfo?.euVatNumber || '-' }}</div>
        </div>

        <h5 class="bold">Telephelyek</h5>
        <div class="field-wrapper">
          <div v-if="!company.companyFullInfo?.workingSites || company.companyFullInfo?.workingSites.length === 0">-
          </div>
          <template v-else>
            <div v-for="(site, index) in company.companyFullInfo?.workingSites" :key="'site-'+index">
              {{ site }}
            </div>
          </template>
        </div>

        <h5 class="bold">Bankszámlák</h5>
        <div class="field-wrapper">
          <div v-if="!company.companyFullInfo?.bankAccounts || company.companyFullInfo?.bankAccounts.length === 0">-
          </div>
          <template v-else>
            <div v-for="(account, index) in company.companyFullInfo?.bankAccounts" :key="'account-'+index">
              {{ account }}
            </div>
          </template>
        </div>

        <h5 class="bold">Értékpapír számlák</h5>
        <div class="field-wrapper">
          <div
              v-if="!company.companyFullInfo?.securitiesBankAccounts || company.companyFullInfo?.securitiesBankAccounts.length === 0">
            -
          </div>
          <template v-else>
            <div v-for="(secAccount, index) in company.companyFullInfo?.securitiesBankAccounts"
                 :key="'sec-account-'+index">
              {{ secAccount }}
            </div>
          </template>
        </div>

        <h5 class="bold">Céges autók</h5>
        <div class="field-wrapper">
          <div v-if="!company.companyFullInfo?.companyCars || company.companyFullInfo?.companyCars.length === 0">-</div>
          <template v-else>
            <div v-for="(car, index) in company.companyFullInfo?.companyCars" :key="'car-'+index">
              {{ car }}
            </div>
          </template>
        </div>

        <h5 class="bold">Pénztárgépek</h5>
        <div class="field-wrapper">
          <div v-if="!company.companyFullInfo?.cashRegisters || company.companyFullInfo?.cashRegisters.length === 0">-
          </div>
          <template v-else>
            <div v-for="(register, index) in company.companyFullInfo?.cashRegisters" :key="'register-'+index">
              {{ register }}
            </div>
          </template>
        </div>

        <h5 class="bold">Terminálok</h5>
        <div class="field-wrapper">
          <div v-if="!company.companyFullInfo?.terminals || company.companyFullInfo?.terminals.length === 0">-</div>
          <template v-else>
            <div v-for="(terminal, index) in company.companyFullInfo?.terminals" :key="'terminal-'+index">
              {{ terminal }}
            </div>
          </template>
        </div>

        <h5 class="bold">Számla tömbök</h5>
        <div class="field-wrapper">
          <div v-if="!company.companyFullInfo?.invoiceBooks || company.companyFullInfo?.invoiceBooks.length === 0">-
          </div>
          <template v-else>
            <div v-for="(book, index) in company.companyFullInfo?.invoiceBooks" :key="'book-'+index">
              {{ book }}
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Api from "api-client";

export default {
  name: "CompanyEditor",
  components: {},

  data() {
    return {
      company: {},
    };
  },

  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },

  computed: {},

  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';

      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}.${month}.${day} ${hours}:${minutes}`;
    },

    loadCompany() {
      Api.getCompany(this.companyId).then((resp) => {
        this.company = resp.data;
      });
    },

  },

  mounted() {
    this.loadCompany();
  },
};
</script>
<style scoped>
.field-wrapper {
  min-height: 45px;
}

.field-wrapper div {
  font-family: JumperThin !important;
}

.bold {
  font-weight: bold;
}

.alert-info {
  background-color: #AEC0C7;
  color: #212529;
  border: none;
  border-radius: 32px;
}
</style>

